import { supabase } from "@/lib/supabase/client";

// Always derive the owner from the live session — never from caller-supplied ids.
export async function requireUserId() {
  const { data } = await supabase.auth.getSession();
  const id = data.session?.user?.id;
  if (!id) throw Object.assign(new Error("No active session"), { code: "session_missing" });
  return id;
}
